import axios from "~axios"

const price = {
    amount: 0,
    amount_formatted: "",
    amount_rounded: 0,
    currency: {
        code: "",
        code_digital: 0,
        html_code: "",
        html_letter_code: "",
        id: 1,
        is_active: true,
        is_main_group: 1,
        name: "",
        order: "",
        sub_unit: ""
    }
}

export default {
    namespaced: true,
    state: {
        currentSubscription: {
            coupon_id: null,
            created_at: "",
            days_left: 0,
            days_left_formatted: "",
            end_at: null,
            expires_at: "",
            id: 0,
            is_canceled: false,
            is_limit_exceeded: false,
            is_trial: true,
            period_type: "",
            period_type_id: 0,
            price_converted: price,
            price_default: price,
            price_discounted_converted: price,
            state_id: 0,
            tariff_id: 0,
            tariff: {
                currency_id: 0,
                id: 0,
                is_popular: 0,
                is_trialable: true,
                name: "",
                price: "",
                price_annual: ""
            }
        },

        currentTariff: {
            currency_id: 0,
            general_settings: {
                id: 0,
                is_readonly: false,
                are_products_on_sale: false,
                are_products_public: false,
                tariff_id: 0,
                user_id: 0
            },
            id: 0,
            is_popular: false,
            is_trialable: true,
            name: "",
            price: "",
            price_annual: ""
        },

        tariffs: []
    },

    getters: {
        currentSubscription: state => state.currentSubscription,
        currentTariff: state => state.currentTariff,
        tariffs: state => state.tariffs
    },

    mutations: {
        SET_CURRENT_SUBSCRIPTION(state, payload) {
            state.currentSubscription = payload
        },

        SET_CURRENT_TARIFF(state, payload) {
            state.currentTariff = payload
        },

        SET_TARIFFS(state, payload) {
            state.tariffs = payload
        }
    },

    actions: {
        async fetchCurrentSubscription({ commit }) {
            try {
                const response = await axios("/tariffs/subscriptions/active")
                const { data } = response.data
                commit("SET_CURRENT_SUBSCRIPTION", data)
            } catch (e) {
                commit("SET_CURRENT_SUBSCRIPTION", {})
                // console.log(e) //handle Exception
            }
        },

        async subscriptionTariff() {
            try {
                const response = await axios.post("/tariffs/subscriptions/activate")
                return response
            } catch (e) {
                throw new Error(e)
            }
        },

        async fetchCurrentTariff({ commit }) {
            try {
                const response = await axios("/tariffs/active")
                const { data } = response.data
                commit("SET_CURRENT_TARIFF", data)
            } catch (e) {
                throw new Error(e)
            }
        },

        async fetchTariffs({ commit }, payload = {}) {
            try {
                const formatted = payload.withFormatted ? "?with_formatted=1" : ""
                const response = await axios(`/tariffs${formatted}`)
                const { data } = response.data
                commit("SET_TARIFFS", data)
            } catch (e) {
                throw new Error(e)
            }
        },
        async changePeriod(state, payload = null) {
            try {
                const response = await axios.put(`/tariffs/subscriptions/period`, payload)
                return response.data
            } catch (e) {
                throw new Error(e)
            }
        },
        async unsubscribe({ dispatch }, payload) {
            try {
                const response = await axios.post("/tariffs/subscriptions/cancel", payload)
                dispatch("fetchCurrentSubscription")
                return response
            } catch (e) {
                throw new Error(e)
            }
        },
        async addServiceForTariff(state, serviceId) {
            try {
                const response = await axios.post(`/tariffs/subscriptions/services/${serviceId}`)
                return response.data
            } catch (e) {
                throw new Error(e)
            }
        },
        async deleteServiceFromTariff(state, serviceId) {
            try {
                const response = await axios.delete(`/tariffs/subscriptions/services/${serviceId}`)
                return response.data
            } catch (e) {
                throw new Error(e)
            }
        }
    }
}
